import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  InputGroup,
  Form,
  ListGroup,
  ListGroupItem,
  CloseButton,
} from "react-bootstrap";
import "./SelectEmployee.css";
export { default as EmployeeDeleteModal } from "./EmployeeDeleteModal";
export { default as EmployeeDeleteToast } from "./EmployeeDeleteToast";

export default function SelectEmployee(props) {
  const {
    className,
    defaultText = "",
    employeesValue,
    setEmployeeId,
    setStaffName,
    staffName,
    isDeleted,
  } = props || {};
  const [employee, setEmployee] = useState("");
  const [openOptions, setOpenOptions] = useState(false);
  const selectEmployeeRef = useRef(null);

  const selectEmployee = (Name, id) => {
    setEmployee(Name);
    setEmployeeId(id);
    setStaffName(Name);
    setOpenOptions(false);
  };

  const inputClick = () => {
    setOpenOptions(!openOptions);
  };

  const searchEmployeeFilter = (evt) => {
    evt.preventDefault();
    setEmployee(evt.target.value);
  };

  const clearInput = (evt) => {
    evt.stopPropagation();
    setEmployee("");
    setStaffName("");
    setOpenOptions(true);
    setEmployeeId();
  };

  useEffect(() => {
    const closeOutsideClick = (evt) => {
      if (
        selectEmployeeRef.current &&
        !selectEmployeeRef.current.contains(evt.target)
      ) {
        setOpenOptions(false);
      }
    };

    const closeOnEscape = (evt) => {
      if (evt.key === "Escape") {
        setOpenOptions(false);
      }
    };

    document.addEventListener("click", closeOutsideClick);
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.removeEventListener("click", closeOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [selectEmployeeRef]);

  useEffect(() => {
    if (employee.length < staffName.length) {
      setStaffName("");
    }

    if (isDeleted) {
      setEmployee("");
    }
  }, [employee, isDeleted]);

  const filteredEmployees = employeesValue?.filter((filteredemployee) =>
    filteredemployee?.Name?.toLowerCase().includes(employee.toLowerCase())
  );

  return (
    <Container as="div" className="p-0">
      <InputGroup
        className="position-relative"
        ref={selectEmployeeRef}
        onClick={inputClick}
      >
        <Container className="position-relative d-flex align-items-center px-0 border">
          <Form.Control
            type="search"
            className={`${className} w-100 p-0 px-2`}
            placeholder={defaultText}
            aria-label="employee input"
            value={employee}
            onChange={searchEmployeeFilter}
          />
          {employee.length > 0 && (
            <CloseButton
              className="position-absolute"
              style={{ right: 10 }}
              onClick={clearInput}
            />
          )}
        </Container>

        {openOptions && (
          <Container
            className="bg-light position-absolute border border-1 rounded p-0"
            style={{ marginTop: "37px", zIndex: "1" }}
          >
            <ListGroup as="ul" variant="flush" className="scroll-enable-y-axis">
              {filteredEmployees.length ? (
                filteredEmployees?.map(({ Name, id }) => {
                  return (
                    <ListGroup.Item
                      className="is-clickable"
                      as="li"
                      action
                      variant="light"
                      key={id}
                      eventKey={id}
                      onClick={() => selectEmployee(Name, id)}
                    >
                      {Name}
                    </ListGroup.Item>
                  );
                })
              ) : (
                <ListGroupItem>No staff found!</ListGroupItem>
              )}
            </ListGroup>
          </Container>
        )}
      </InputGroup>
    </Container>
  );
}
